import React, { FunctionComponent } from 'react';

import callOutImgSrc from './assets/NominateYourHero_2026.png';
import styles from './CallOut.module.scss';
import config from '../../config';

export const CallOut: FunctionComponent = () => {
  return (
    <section className={styles.callOut}>
      <div className={`container ${styles.container}`}>
        <div className={`jg-space-mtsm ${styles.callOutWrapper}`}>
          <div className={`jg-display-ib ${styles.content}`}>
            <h2 className={`jg-display-ib jg-space-ptmd ${styles.header}`}>
              The 2026 JustGiving Awards are back!
            </h2>
            <p className={`jg-display-ib ${styles.description} jg-space-mtsm`}>
              Know an incredible fundraiser who's gone the extra mile for a
              cause they love? Help give them the recognition they deserve.
              Nominate your fundraising hero today.
            </p>

            <div className={`jg-space-mtsm ${styles.buttonWrapper}`}>
              <a
                className={`jg-btn--ghost jg-space-mbm ${styles.button}`}
                href={config.jgAwardsUrl}
              >
                Nominate now
              </a>
            </div>
          </div>

          <div className={`jg-display-ib ${styles.content} jg-flex-asc`}>
            <a href={config.jgAwardsUrl} tabIndex={-1} aria-hidden>
              <img
                src={callOutImgSrc}
                alt="Nominate now"
                className={`jg-space-psm callOut-img ${styles.callOutImg}`}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
